import React from "react";

export const AppleStoreDownload = ({ isFooterIcon = false }) => {
  return (
    <a target="tab" href="https://apps.apple.com/sg/app/speedoc/id1288838601?mt=8">
      <img
        width="135px"
        alt="Get it on Apple Store"
        src={
          isFooterIcon
            ? "https://public.speedoc.com/strapi/applestore_f9874d73df.svg"
            : "https://public.speedoc.com/design/images/speedoc.com/store/apple_store_dark.svg"
        }
      />
    </a>
  );
};

export const GoogleStoreDownload = ({ isFooterIcon = false }) => {
  return (
    <a
      target="tab"
      href="https://play.google.com/store/apps/details?id=com.speedoc.patient&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
      <img
        width="135px"
        alt="Get it on Google Play"
        src={
          isFooterIcon
            ? "https://public.speedoc.com/strapi/playstore_0640c0ec1f.svg"
            : "https://public.speedoc.com/design/images/speedoc.com/store/google_play_dark.svg"
        }
      />
    </a>
  );
};

export const StoreButtons = ({ isFooterIcon = false }) => {
  return (
    <div className="stores">
      <button className="appStore ios" type="button" aria-label="get ios app">
        <AppleStoreDownload isFooterIcon={isFooterIcon} />
      </button>
      <button className="appStore android" type="button" aria-label="get android app">
        <GoogleStoreDownload isFooterIcon={isFooterIcon} />
      </button>
    </div>
  );
};
